<template>
  <div class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="mb-0">
          {{ $t("informaceOSpravci") }}
        </h2>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    admin: Object
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
